module.exports = __webpack_public_path__ + "static/media/background-image.99555319.webp";